/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHttpService, ILogService, IPromise, IQService} from 'angular';
import TSGemeinde from '../../models/TSGemeinde';
import IRootScopeService = angular.IRootScopeService;

/**
 * Service zum verwalten von Gemeinden.
 */
export default class GemeindeRS {

    static $inject = ['$http', 'CONSTANTS', '$q', '$rootScope', '$log'];
    /* @ngInject */
    constructor(private $http: IHttpService, private CONSTANTS: any, private $q: IQService,
                private $rootScope: IRootScopeService, private $log: ILogService) {
    }

    public readGemeindeSuggestion(searchString: string, exlcudeKantonGR: boolean): IPromise<Array<TSGemeinde>> {
        return this.$http.get(this.CONSTANTS.REST_API + 'gemeinden/public/',
            {
                params: {
                    gemeindeName: searchString,
                    excludeKantonGR: exlcudeKantonGR
                }
            })
            .then((response) => {
                if (response.data !== undefined) {
                    this.$log.debug('PARSING Gemeinden REST  object', response.data);
                    return TSGemeinde.deserializeArray(response.data);
                } else {
                    return [];
                }
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/GemeindeRS.rest.ts